<div  [class.rtl]="isCurrentLanguageArabic" [attr.dir]="isCurrentLanguageArabic  ? 'rtl' : ''">
  <h2 *ngIf="title" class="title" matDialogTitle>{{ title }}</h2>
  <p class="message" mat-dialog-content>{{confirmMessage}}</p>
  <div class="divider"></div>
  <div mat-dialog-actions class="btn-group">
    <button mat-raised-button color="accent" (click)="dialogRef.close(true)">{{'SHARED.Button.Yes' | translate }}</button>
    <button mat-raised-button color="accent" (click)="dialogRef.close(false)">{{'SHARED.Button.No' | translate }}</button>
  </div>
</div>
